export default __webpack_public_path__ + "static/media/modernizr.89e2c2ca.svg";